import React from 'react'
import { LOCALE } from '../../../constants/activity-constants'

const ec = LOCALE === "es-EC"
const arg = LOCALE === "es-AR"
const py = LOCALE === "es-PY"
const uy = LOCALE === "es-UY"

export let textCountry = {};
if (arg) {
  textCountry = {
    text1: 'Iniciá sesión',
    text2: 'acá'
  }
}else{
  textCountry = {
    text1: 'Inicia sesión',
    text2: 'aquí.'
  }
}
export const Text1ByCountry = ({topNumber, activity_dates}) => {
  let text;
  if (arg) {
    text = <>
      <b>Si no estás en nuestro top {topNumber} </b>
      ¡seguí jugando!  
      <b> tenés hasta el {activity_dates}{' '}</b>
      para alcanzar los mejores puntajes.
      <br />
    </>
  }else if (ec) {
    text = <>
      <b>Si no estás en nuestro top {topNumber} </b>
      ¡sigue jugando!  
      <b> tienes hasta el {activity_dates}{' '}</b>
      para alcanzar los mejores puntajes.
      <br />
    </>
  }else{
    text = <>
      <b>
        Si no estás en nuestro top {topNumber} ¡sigue jugando! tienes hasta el {activity_dates}{' '}
      </b>
      para alcanzar los mejores puntajes.
      <br />
    </>
  }

  return (
    text
  )
}
const Text2ByCountry = () => {
  let text;
  if (arg) {
    text = <>
      <br />
      <b>Guardá TODOS tus empaques! </b> <br/> La marca te los pedirá
      si llegas a ser ganadora y solo presentándolos recibirás tu premio.
    </>
  }else{
    text = <>
      <br />
      <b>¡Recuerda guardar TODOS tus empaques! </b> La marca te los pedirá
      si llegas a ser ganadora y solo presentándolos recibirás tu premio.
    </>
  }

  return (
    text
  )
}
const Text3ByCountry = () => {
  let text;
  if (arg) {
    text = <>
      <b>Sos la mejor acumulando puntos en cada planeta? </b>¡Entonces
      buscá tu nombre entre los mejores puntajes! <br /> <br />
    </>
  }else{
    text = <>
      <b>¿Eres la mejor acumulando puntos en cada planeta? </b>¡Entonces
      busca tu nombre entre los mejores puntajes! <br /> <br />
    </>
  }

  return (
    text
  )
}
const Text4ByCountry = () => {
  let text;
  if (arg) {
    text = <>
      {' '}para conocer
      tu puntaje y tu posición dentro del top de jugadoras. Si aún no
      sos parte de NosotrasOnline regístrate{' '}
    </>
  }else{
    text = <>
      {' '}para conocer
      tu puntaje y tu posición dentro del top de jugadoras. Si aún no
      formas parte de NosotrasOnline regístrate{' '}
    </>
  }

  return (
    text
  )
}
export const text_replica_content_top2 = Text2ByCountry()
export const text_replica_content_top3 = Text3ByCountry()
export const text_replica_content_top4 = Text4ByCountry()
